import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const Logo = ({ variant = 'full' }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  if (variant === 'icon') {
    return (
      <motion.svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.path
          d="M24 4L4 14V34L24 44L44 34V14L24 4Z"
          stroke="#00AA66"
          strokeWidth="2"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        />
        <motion.path
          d="M24 14L14 19V29L24 34L34 29V19L24 14Z"
          fill="#00AA66"
          fillOpacity="0.3"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        />
        <motion.circle
          cx="24"
          cy="24"
          r="4"
          fill="#00AA66"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.8, duration: 0.3 }}
        />
      </motion.svg>
    );
  }

  return (
    <motion.div
      className="flex items-center gap-3"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <svg
        width="42"
        height="42"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        <motion.path
          d="M24 4L4 14V34L24 44L44 34V14L24 4Z"
          stroke="#00AA66"
          strokeWidth="2.5"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        />
        <motion.path
          d="M24 14L14 19V29L24 34L34 29V19L24 14Z"
          fill="#00AA66"
          fillOpacity="0.4"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        />
        <motion.circle
          cx="24"
          cy="24"
          r="5"
          fill="#00AA66"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.6, duration: 0.3 }}
        />
      </svg>
      <div className="flex flex-col leading-tight">
        <div className="text-2xl font-bold font-manrope tracking-tight flex items-baseline">
          <span className="text-brand-primary">Serendi</span>
          <span className={isDark ? 'text-dark-text' : 'text-light-text'}>Tech</span>
        </div>
        <span className={`text-[10px] font-medium tracking-wide ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
          DISCOVER INTELLIGENCE SOLUTIONS
        </span>
      </div>
    </motion.div>
  );
};

export default Logo;